<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddEmail()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_email.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getInfoEmail()" v-if="permissionList.includes(permission.info)">{{$t('setting_email.table_info')}}</b-button>
                            <b-button variant="primary" size="lg" class="ml-1" @click="getEditEmail()" v-if="permissionList.includes(permission.edit)">{{$t('setting_email.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteEmail()" v-if="permissionList.includes(permission.delete)">{{$t('setting_email.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addEmail" :title="$t('setting_email.table_add')" size="lg" @ok="addEmail" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addEmailForm" @submit.prevent="addEmail">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_email.table_code')}}</template>
                            <b-form-input name="code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_email.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_email.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch  v-model="ajaxAdd.status"></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_email.table_description')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name" class="pt-3 custom-from-group">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_email.table_title')}}</template>
                                        <b-form-input :name="'title[' + lang.code + ']'"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label-cols="12" label-cols-lg="12">
                                        <template slot="label">{{$t('setting_email.table_content')}}</template>
                                        <quill-editor class="custome-editor" v-model="ajaxAdd.content[lang.code]"></quill-editor>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editEmail" :title="$t('setting_email.table_edit')" size="lg" @ok="editEmail" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editEmailForm" @submit.prevent="editEmail">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_email.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_email.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_email.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch  v-model="ajaxEdit.status"></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_email.table_description')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name" class="pt-3 custom-from-group">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_email.table_title')}}</template>
                                        <b-form-input :name="'title[' + lang.code + ']'" v-model="ajaxEdit.title[lang.code]"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label-cols="12" label-cols-lg="12">
                                        <template slot="label">{{$t('setting_email.table_content')}}</template>
                                        <quill-editor class="custome-editor" v-model="ajaxEdit.content[lang.code]"></quill-editor>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="infoEmail" :title="ajaxInfo.title" size="lg" hide-footer="">
                    <p v-html="ajaxInfo.content"></p>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,emailAjaxTable,getEmailAdd,emailAdd,getEmailEdit,emailEdit,emailDelete,emailCheckPackage,emailInfo} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',at_id:'',attribute_id:'',package_id:'',formula:''},
            ajaxAdd:{languageList:[],status:1,content:[],sort:100},
            ajaxEdit:{languageList:[]},
            ajaxInfo:[],
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'EB4F3E',
                edit:'BE7421',
                delete:'549B41',
                info:'AE63B2'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_email.table_id'),
                width: '277'
            },{
                prop: "code",
                label: this.$t('setting_email.table_code'),
                width: '415'
            },{
                prop: "sort",
                label: this.$t('setting_email.table_sort'),
                width: '415'
            },{
                prop: "status",
                label: this.$t('setting_email.table_status'),
                width: '415'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = emailAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.at_id,this.ajaxSearch.attribute_id,this.ajaxSearch.package_id);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddEmail(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = getEmailAdd();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('addEmail')
                        self.ajaxAdd.languageList = value.data.language_list;
                        for(var i = 0;i<self.ajaxAdd.languageList.length;i++){
                            self.ajaxAdd.content.push(self.ajaxAdd.languageList[i].code);
                        }
                    }
                });
            }
        },addEmail(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(this.validate){
                    var form = document.getElementById('addEmailForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue);
                    for(var i = 0;i<self.ajaxAdd.languageList.length;i++){
                        formData.append('content['+self.ajaxAdd.languageList[i].code+']', this.ajaxAdd.content[self.ajaxAdd.languageList[i].code]); 
                    }
                    var result = emailAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }  
            }       
        },getInfoEmail(){
            if(this.permissionList.includes(this.permission.info)){
                var self = this;
                var result = emailInfo(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('infoEmail');
                        self.ajaxInfo = value.data;
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },getEditEmail(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getEmailEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editEmail');
                        self.ajaxEdit = value.data.this_detail;
                        self.ajaxEdit.languageList = value.data.language_list;
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editEmail(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                if(this.validate){
                    var form = document.getElementById('editEmailForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    for(var i = 0;i<self.ajaxEdit.languageList.length;i++){
                        formData.append('content['+self.ajaxEdit.languageList[i].code+']', this.ajaxEdit.content[self.ajaxEdit.languageList[i].code]); 
                    }
                    var result = emailEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },deleteEmail(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = emailDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
